module.exports = __webpack_public_path__ + "img/server.7b2d4166.png";